export default class PartnerStatistics {
  /**
   * Create new partner statistics and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }
}
